module.exports = "/assets/655124ae5f8436b99bc1983969a6ec61.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KT.png
// module id = 2681
// module chunks = 0